import { createFileRoute } from '@tanstack/react-router';
import { fallback, zodValidator } from '@tanstack/zod-adapter';
import messages from 'app/_authenticated/funds/messages';
import SEO from 'components/Seo/Seo';
import { useSelector } from 'react-redux';
import { RootState } from 'store/reducer';
import { z } from 'zod';
import { AllTransactions } from './all/AllTransactions';
import { FundsTransactionsComponent } from './funds/FundsTransactions';
import { PendingTransactionsComponent } from './pending/PendingTransactions';
import { RewardsTransactionsComponent } from './rewards/RewardsTransactions';
import { SavingsTransactionsComponent } from './savings/SavingsTransactions';
import { transactionTypes } from './transactionTypes';

const searchParamsSchema = z.object({
  type: fallback(z.enum(transactionTypes), 'all').default('all'),
});

export const Route = createFileRoute('/_authenticated/activity')({
  component: Transactions,
  validateSearch: zodValidator(searchParamsSchema),
});

const pageDescriptions = {
  all: 'all-transactions',
  pending: 'pending-transactions',
  funds: 'completed-transactions',
  savings: 'vault-transactions',
  rewards: 'rewards-transactions',
};

function Transactions() {
  const { type } = Route.useSearch();
  const { language } = useSelector(
    (rootState: RootState) => rootState.language,
  );
  const transactionsMessages = messages[language];

  const pageDescription = pageDescriptions[type];

  return (
    <>
      <SEO
        title={transactionsMessages.seo.title}
        description={transactionsMessages.seo.description}
        keywords={transactionsMessages.seo.keywords}
        page={pageDescription}
      />
      <div className="px-6 py-4">
        {type == 'all' && <AllTransactions />}
        {type == 'pending' && <PendingTransactionsComponent />}
        {type == 'funds' && <FundsTransactionsComponent />}
        {type == 'savings' && <SavingsTransactionsComponent />}
        {type == 'rewards' && <RewardsTransactionsComponent />}
      </div>
    </>
  );
}
